<template>
  <v-chart v-if="collectOnlineMetrics.data" ref="chart" :option="chartData" autoresize class="online-chart" />
</template>

<script>
import { mapState } from 'vuex'
import dayjs from 'dayjs'

export default {
    props: {
        collectOnlineMetrics: { type: Object, required: true },
        loading: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState('ui/settings', {
            firstPartyCookie: state => state.general.firstPartyCookie,
            providerFirstIdActivated: state => state.general.providerFirstIdActivated,
            providerUtiqActivated: state => state.general.providerUtiqActivated,
        }),
        idsList() {
            const idsList = [
                { shortName: '3cl', fullName: 'Cookie (CRM IDs)', color: '#779CE6', show: true },
                { shortName: '3wb', fullName : 'Cookie (Weborama)', color: '#4F7FD6', show: true },
                { shortName: '1st', fullName: 'Cookie (1st Party)', color: '#189CFB', show: this.firstPartyCookie || false },
                { shortName: 'fid', fullName: 'First id', color: '#FAB91F', show: this.providerFirstIdActivated || false },
                { shortName: 'mob', fullName: 'Mobile', color: '#BD3ADE', show: true },
                { shortName: 'uho', fullName: 'Utiq Home', color: '#F01944', show: this.providerUtiqActivated || false },
                { shortName: 'umo', fullName: 'Utiq Mobile', color: '#590BFF', show: this.providerUtiqActivated || false }
            ]
            return idsList.filter(id => id.show)
        },
        chartData() {
            const { hours, data } = this.collectOnlineMetrics
            const dateFormat = hours ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY'
            return {
                color: this.idsList.map(({ color }) => color),
                tooltip: { trigger: 'axis', axisPointer: { type: 'line' } },
                legend: { bottom: 0, icon: 'rect', textStyle: { color: '#809FB8' }, data: this.idsList.map(({ fullName }) => fullName) },
                grid: { left: '5%', right: '5%', top: '10%', bottom: '22%' },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: data[this.idsList[0].shortName]?.map(({ date }) => dayjs(date).utc().format(dateFormat)) || [],
                    axisLine: { lineStyle: { color: '#809FB8' } },
                    axisTick: { show: false },
                    splitLine: { show: true, lineStyle: { color: 'rgba(217,225,231,0.6)' } }
                },
                yAxis: {
                    type: 'value',
                    axisLine: { lineStyle: { color: '#809FB8' } },
                    axisTick: { show: false },
                    splitLine: { show: false }
                },
                series: this.idsList.map((id) => {
                    return {
                        name: id.fullName,
                        type: 'line',
                        stack: 'total',
                        smooth: true,
                        symbol: 'none',
                        lineStyle: { width: 0 },
                        areaStyle: { opacity: 0.55, color: id.color },
                        emphasis: { focus: 'series' },
                        data: data[id.shortName]?.map(({ value }) => value)
                    }
                })
            }
        }
    },
    watch: {
        idsList() {
            this.resetChart()
        },
    },

    methods: {
        resetChart() {
            this.$nextTick(() => {
                const chart = this.$refs.chart?.chart

                if (chart) {
                    chart.clear()
                    chart.setOption(this.chartData, true)
                }
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.online-chart {
  height: 300px;
  width: 100%;
}
</style>
